import { postRequest } from '../clients/axios';
import { SavePlayerAddressPayload, SavePlayerAddressResponse } from '../models';

export const postSavePlayerAddress = async (data: SavePlayerAddressPayload) => {
  const url = 'player/saveplayeraddress';
  const response = await postRequest<SavePlayerAddressResponse>(url, data);
  return response;
};
